import React from "react";
import Icon from "../Icon";
import S from "./MessageActions.styled";
const MessageActions = ({ actions, }) => {
    if (actions.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(S.Wrapper, { className: "message-actions" }, actions.map((action) => (React.createElement(S.ActionButton, { type: "button", "aria-label": action.id, key: action.id, onClick: action.onClick },
        React.createElement(Icon, { name: action.icon }))))));
};
export default MessageActions;
//# sourceMappingURL=MessageActions.js.map